import React from 'react'
import injectSheet from 'react-jss'
import Dropzone from 'react-dropzone'
import { Image } from '../../'

class FileInput extends React.Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.file !== prevState.file) {
      return ({
        file: nextProps.file,
      })
    }
    return null
  }

  constructor(props) {
    super(props)

    this.state = {
      error: null,
      file: props.file,
    }

    this.onDrop = this.onDrop.bind(this)
  }

  onDrop(file) {
    if (file.length > 0) {
      this.props.handleSelect(file[0])
      this.setState({
        error: null,
      })
      return true
    }
    this.setState({
      error: 'Die gewählte Datei ist zu gross (max. 4MB). Bitte versuchen Sie es erneut...',
    })
    return false
  }

  render() {
    const {
      accept,
      classes,
      maxSize,
      theme,
    } = this.props

    const {
      error,
      file,
    } = this.state

    return (
      <div className={`${classes.uploadContainer}`}>
        <div className={`${classes.fileContainer}`}>
          {file && (
            <div
              className={`${classes.file}`}
            >
                {(typeof (file) === 'string') ? (
                  <Image src={file} />
                ) : (
                  <Image fullPath={file.preview} />
                )}
            </div>
          )}
          <Dropzone
            accept={accept}
            onDrop={this.onDrop}
            maxSize={maxSize}
            multiple={false}
            style={{
              width: '100%',
              height: '100%',
              border: `3px dashed ${theme.colors.secondary_3a}`,
              borderRadius: '3px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              textAlign: 'center',
              padding: `0 ${(theme.sizes.gutter)}px`,
              color: (error ? theme.colors.main_1 : theme.colors.main_3),
            }}
          >
            {!error ? 'Datei hier droppen oder klicken' : error}
          </Dropzone>
        </div>
      </div>
    )
  }
}

const styles = theme => ({
  uploadContainer: {},
  fileContainer: {
    display: 'flex',
    flexWrap: 'nowrap',
    width: '100%',
    height: '100px',
  },
  file: {
    marginRight: `${(theme.sizes.gutter / 2)}px`,
    width: '40%',
  },
})

export default injectSheet(styles)(FileInput)



// WEBPACK FOOTER //
// ./src/modules/core/components/fileInput.jsx